import type { GetClassResponse } from "@/openapi/generated/models";

/** Teacher id the attendance API requires for this class (first assigned teacher). */
export function getPrimaryClassTeacherId(
  classData:
    | Pick<GetClassResponse, "teachers">
    | null
    | undefined,
): number | null {
  const teachers = classData?.teachers ?? [];
  for (const teacher of teachers) {
    const id = Number(teacher.teacherId);
    if (Number.isFinite(id) && id > 0) return id;
  }
  return null;
}
